/** Built-in vector picture definitions (region geometry generated in code). */

export interface PicturePaletteColor {
  colorId: number;
  number: number; // paint-by-number label
  hex: string;
}

export interface PictureCell {
  cellId: number;
  colorId: number;
  cx: number; // number-anchor x in picture-space [0..VIEW] (pole of inaccessibility)
  cy: number;
  labelR?: number; // inscribed radius at the anchor; sizes the paint-number to fit the region
  poly: number[]; // flat polygon [x0,y0,...] in picture-space
}

export interface PictureDef {
  id: string;
  title: string;
  sizeName: string; // matches a picture_spec name ('small'|'medium'|'large')
  /** Logical drawing canvas size; cells live in this coordinate space. */
  view: number;
  palette: PicturePaletteColor[];
  cells: PictureCell[];
  /** A short scene-setting accent gradient for the gallery card backdrop. */
  cardTint: [string, string];
  /** URL of the smooth posterized base image; the canvas reveals it region-by-region. */
  image?: string;
  /** URL of the original photo — the gallery uses it as the thumbnail "promise of the result". */
  sourceImage?: string;
  /** Discovery tags — drive the gallery category chips (Luxury / Animals / Drinks / Cars / City …). */
  tags?: string[];
  /** Shared-edge ink network: each entry is one boundary polyline [x0,y0,x1,y1,…] in picture
   *  coords. Every boundary appears ONCE (no doubled lines from per-region stroking). */
  ink?: number[][];
}

/** The on-canvas coordinate space every built-in picture is authored in. */
export const VIEW = 1000;
